<template>
  <section class="page-card">
    <h1 class="page-title">{{ $t('pages.users') }}</h1>
    <div class="filter-bar">
      <el-input v-model="search.user_id" :placeholder="$t('common.userId')" class="filter-item" size="small"></el-input>
      <el-input v-model="search.phone" :placeholder="$t('common.phone')" class="filter-item" size="small"></el-input>
      <el-date-picker v-model="search.created_at__gte" type="date" value-format="yyyy-MM-dd" :placeholder="$t('common.start')" class="filter-item" size="small"></el-date-picker>
      <el-date-picker v-model="search.created_at__lt" type="date" value-format="yyyy-MM-dd" :placeholder="$t('common.end')" class="filter-item" size="small"></el-date-picker>
      <el-button type="primary" size="small" @click="reload">{{ $t('actions.search') }}</el-button>
    </div>
    <div class="table-scroll">
      <el-table :data="tableData" border stripe>
        <el-table-column prop="user_id" :label="$t('common.userId')" min-width="100"></el-table-column>
        <el-table-column prop="user_name" :label="$t('common.username')" min-width="120"></el-table-column>
        <el-table-column prop="phone" :label="$t('common.phone')" min-width="120"></el-table-column>
        <el-table-column prop="email" :label="$t('common.email')" min-width="160"></el-table-column>
        <el-table-column prop="pkg" :label="$t('common.packageName')" min-width="150"></el-table-column>
        <el-table-column prop="area_code" :label="$t('common.areaCode')" min-width="80"></el-table-column>
        <el-table-column prop="currency_code" :label="$t('common.currency')" min-width="80"></el-table-column>
        <el-table-column prop="balance" :label="$t('common.balance')" min-width="100"></el-table-column>
        <el-table-column prop="recharge_total" :label="$t('pages.rechargeTotal')" min-width="120"></el-table-column>
        <el-table-column prop="withdraw_total" :label="$t('pages.withdrawTotal')" min-width="120"></el-table-column>
        <el-table-column prop="created_at" :label="$t('common.createdAt')" min-width="160"></el-table-column>
      </el-table>
    </div>
    <el-pagination
      :total="count"
      :current-page.sync="search.page"
      :page-size="search.size"
      layout="total, prev, pager, next"
      @current-change="loadData"
    ></el-pagination>
  </section>
</template>

<script>
import { defaultDateRange, isDateRangeOverDays } from '../utils/date';

export default {
  name: 'Users',
  data() {
    const range = defaultDateRange();
    return {
      search: { page: 1, size: 20, created_at__gte: range[0], created_at__lt: range[1] },
      tableData: [],
      count: 0
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    reload() {
      this.search.page = 1;
      this.loadData();
    },
    validateDateRange() {
      if (!isDateRangeOverDays(this.search.created_at__gte, this.search.created_at__lt, 31)) return true;
      this.$message.error(this.$t('common.dateRangeTooLong'));
      return false;
    },
    async loadData() {
      if (!this.validateDateRange()) return;
      const resp = await this.$axios.get('/admin/exagent/console/users/', { params: this.search });
      if (resp.data.status !== 0) return;
      const data = resp.data.data || {};
      this.tableData = data.list || [];
      this.count = data.count || 0;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Users.vue